/*
 * Copyright (c) Worldline 2023.
 */

export const ExternalEvidenceTempDataStatus = {
    PROCESSING: 'PROCESSING',
    AFFECTATION: 'AFFECTATION',
    TO_CROP_AND_AFFECTATION: 'TO_CROP_AND_AFFECTATION',
    TO_CROP: 'TO_CROP',
    AFFECTED: 'AFFECTED',
    REJECT: 'REJECT'
}